import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SoaOrderStatusSummaryModel } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import { ApiResultModel, getSoaSubscribers } from "@WhiteCap/Store/Service/SoaSubscribersService";

export interface SubscriptionsDashboardApiParameter extends ApiParameter {
    customerId?: string;
    onError?: (error: string) => void;
    onSuccess?: (data: SoaOrderStatusSummaryModel) => void;
}
type HandlerType = CustomApiHandler<SubscriptionsDashboardApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginSoaSubscribersDataLoad",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getSoaSubscribers(props.apiParameter.customerId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if(props.apiParameter.onSuccess) {
            const data = {
                properties: result.result.properties,
                subscribedEmails: result.result.subscribedEmails,
                count: result.result.soaOrderStatusSummary?.count,
                isPrintPriceEnabled: result.result.soaOrderStatusSummary?.isPrintPriceEnabled,
            };
            props.apiParameter.onSuccess(data); 
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/SoaSubscriptions/SoaSubscribersDataLoadError",
        });
        return false;
    }
};

export const DispatchCompleteSoaSubscribersDataLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteSoaSubscribersDataLoad",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteSoaSubscribersDataLoad];

const loadSoaSubscribers = createHandlerChainRunner(chain, "LoadSoaSubscribers");
export default loadSoaSubscribers;
